import { useCallback, useState } from "react";
import { session } from "../../lib/api";

/** 로그인이 필요한 동작을 한 곳에서 다룬다. 화면마다 다르게 처리하지 않는다. */
export function useAuthPrompt() {
  const [reason, setReason] = useState<string | null>(null);

  const require = useCallback((why: string, action: () => void): boolean => {
    const ok = session.requireAuth(action);
    if (!ok) setReason(why);
    return ok;
  }, []);

  return { reason, close: () => setReason(null), require };
}
